export default __webpack_public_path__ + "static/media/photo9.1d5e6dbf.jpg";